import React, { createContext, useRef, useState, useContext, useEffect } from 'react';
import { AuthContext, FireactContext, SetPageTitle } from "../../lib/core";
import { collection, onSnapshot, query, orderBy, where, updateDoc, doc, addDoc, serverTimestamp } from "firebase/firestore";

// Create the context
const AppContext = createContext();

// Context Provider
const AppProvider = ({ children }) => {
  const { firestoreInstance } = useContext(AuthContext);
  const { authUser } = useContext(AuthContext);

  const [currentAddress, setCurrentAddress] = useState('');
  const [unreadCount, setUnreadCount] = useState(0);
  const [notifications, setNotifications] = useState([]);

  // Listen to notifications for the current user in realtime.
  useEffect(() => {
      if (!firestoreInstance) {
        console.error("firestoreInstance is not initialized");
        return;
      }
      // Ensure authUser exists and that uid is defined
      if (!authUser || !authUser.user?.uid) return;

      const notificationsRef = collection(firestoreInstance, "notifications");
      // Query for notifications only for the current user.
      const q = query(
        notificationsRef,
        where("userId", "==", authUser.user.uid),
        orderBy("createdAt", "desc")
      );
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const notifList = [];
        let unread = 0;
        querySnapshot.forEach((docSnapshot) => {
          const data = docSnapshot.data();
          notifList.push({ id: docSnapshot.id, ...data });
          if (!data.read) {
            unread++;
          }
        });
        console.log("notifList", notifList);
        setNotifications(notifList);
        setUnreadCount(unread);
      });
  
      return () => unsubscribe();
  }, [firestoreInstance, authUser]);

  return (
    <AppContext.Provider value={{currentAddress, setCurrentAddress, unreadCount, notifications}}>
      {children}
    </AppContext.Provider>
  );
};

export { AppProvider, AppContext };
